import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';

export default class AbortedJobsReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            isLoading:false,
            url:'/api/v1/portal/portal-admin/aborted-jobs-report/',
            abortedJobsReportData:[],
            downloadReportName:'Aborted Jobs Report'
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
    }
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    handleAbortedJobsReportGeneration(e) {
        this.setState({isLoading: true});
        let abortedJobsReportParams = {};
        abortedJobsReportParams.selected_start_date = moment(this.state.startDate).format("YYYY-MM-DD");
        abortedJobsReportParams.selected_end_date = moment(this.state.endDate).format("YYYY-MM-DD");

        let url = this.state.url+abortedJobsReportParams.selected_start_date+'/'+abortedJobsReportParams.selected_end_date;

        return fetch(url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
            this.setState({
              abortedJobsReportData: response,
              isLoading: false
            })
          });
        });
    }
    getCompanyNameById(id){
        let company = '';
        switch(id) {
        case 1:
          company = 'ACV';
          break;
        case 2:
          company = 'SCCD';
          break;
        case 3:
          company = 'CND';
          break;
        case 4:
          company = 'BVL';
          break;
        case 5:
          company = 'G4';
          break;
        case 6:
          company = 'TLC';
          break;
        case 7:
          company = 'ACV-TRUCK';
          break;
        default:
          // code block
      }
      return company;
    }
    download(filename, text) {
        filename = filename+' From '+moment(this.state.startDate).format("YYYY-MM-DD")+' To '+moment(this.state.endDate).format("YYYY-MM-DD")+'.csv';
        let element = document.createElement('a');
        element.setAttribute('href','data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download',filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }
    render() {
        let abortedJobs = [];
        let downloadableCsvDataAborted = "Job Ref,Reg/VIN,Customer,From Address,To Address,Job price,Invoice Date,Invoice Number\n";
        if(this.state.abortedJobsReportData.length > 0){
            this.state.abortedJobsReportData.map((currentJob, index) => {
                let joburl = "/jobs/view/"+currentJob.id;
                let isSplitJob = (currentJob.is_split_job == 1) ? <i className="fa fa-strikethrough split-job-status-is-split-job abort-report" title={"Split Job Parent #"+currentJob.split_parent_id}></i> : "";
                let hasSplitJob = (currentJob.has_split_jobs == 1) ? <i className="fa fa-strikethrough split-job-status-has-split-jobs abort-report"></i> : "";
                let subByCompany = (currentJob.subcontracted_parent_job_id == null && currentJob.subcontracted_job_id != null) ? this.getCompanyNameById(currentJob.subcontracted_by_company_id) : '';
                let subToCompany = (currentJob.subcontracted_parent_job_id == null && currentJob.subcontracted_job_id != null) ? this.getCompanyNameById(currentJob.subcontracted_to_company_id) :'';
                let subcontracted = (currentJob.subcontracted_parent_job_id == null && currentJob.subcontracted_job_id != null) ?  <i className="fa fa-share-alt subcontracted-aborted-jobs-report" title={"Subcontracted from "+subByCompany+" To "+subToCompany}></i> : '';
                abortedJobs.push(
                        <tr key={index}>
                            <td className="job-ref-font16">{hasSplitJob}<a href={joburl}>{currentJob.id}</a>{isSplitJob}{subcontracted}</td>
                            <td>{currentJob.vehicle.registration_number != null ? currentJob.vehicle.registration_number : currentJob.vehicle.vin_number}</td>        
                            <td>{currentJob.customer.name}</td>        
                            <td>{currentJob.pickup_address.address_line_1}</td>        
                            <td>{currentJob.dropoff_address.address_line_1}</td>        
                            <td>&pound;{currentJob.job_price}</td>        
                            <td>{ (currentJob.invoice_date) ? moment(currentJob.invoice_date).format("DD.MM.YY") : ""}</td>        
                            <td>{currentJob.invoice_number}</td>        
                        </tr>
                );
                downloadableCsvDataAborted = downloadableCsvDataAborted +
                                        currentJob.id+','+
                                        currentJob.vehicle.registration_number+','+
                                        currentJob.customer.name+','+
                                        currentJob.pickup_address.address_line_1+','+
                                        currentJob.dropoff_address.address_line_1+','+
                                        currentJob.job_price+','+
                                        ((currentJob.invoice_date) ? moment(currentJob.invoice_date).format("DD.MM.YY") : "")+','+
                                        currentJob.invoice_number+"\n";
            });
        }else{
            abortedJobs.push(
                <tr key='no-records'><td colSpan="8" className='text-center'>No Records</td></tr>
            );
        }
        
        return (
            <div className="container-fluid">
                <div className="row">
                    <h2>Aborted Jobs Report</h2>
                    <br/><br/><br/>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        Select Start Date:
                    </div>
                    <div className="col-md-2">
                       Select End Date:
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-2">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate}/>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-lg btn-success" onClick={(e) => this.handleAbortedJobsReportGeneration(e)}>
                                   <i className="fa fa-save"></i> Generate Aborted Jobs Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg"
                                    onClick={(e) => {
                                    this.download(this.state.downloadReportName, downloadableCsvDataAborted);
                                  }}>
                                <i className="fa fa-download"></i> Download Report
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <h4>{this.state.abortedJobsReportData.length} jobs found..</h4>
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                                <thead className="sticky-top-without-zindex bg-light">
                                    <tr>
                                        <th>Job Ref</th>
                                        <th>Reg/VIN</th>
                                        <th>Customer</th>
                                        <th>From Address</th>
                                        <th>To Address</th>
                                        <th>Job price</th>
                                        <th>Invoice Date</th>
                                        <th>Invoice Number</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {this.state.isLoading ?
                                (<tr><td colSpan="14"><span className="add-loading-text">
                                        <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                    abortedJobs
                                }
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-aborted_jobs_report')) {
    ReactDOM.render(
        <AbortedJobsReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-aborted_jobs_report')
    );
}
